import { useQuery } from '@tanstack/react-query'
import { tokenUsageApi } from '@/lib/api'

export function useTokenUsageSummary() {
  return useQuery({
    queryKey: ['token-usage-summary'],
    queryFn: () => tokenUsageApi.summary(),
    staleTime: 30_000,
  })
}

export function useTokenUsageByAgent(agentName: string) {
  return useQuery({
    queryKey: ['token-usage-agent', agentName],
    queryFn: () => tokenUsageApi.byAgent(agentName),
    staleTime: 30_000,
    enabled: !!agentName,
  })
}
